import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './YourInformation.module.scss'
import { vinSerialNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const VinSerialNumber = ({ t, vinSerialNumberValid, validateVinSerialNumber, vinSerialNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const vinSerialNumber = useSelector((state) => state.app.vinSerialNumber)

  const handleVinSerialNumber = (e) => {
    try {
      let number = e.currentTarget.value.replace(/\s/g, '').toUpperCase()
      dispatch(vinSerialNumberAction(number))
      // validateVinSerialNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validateVinSerialNumber(vinSerialNumber)
  }

  return (
    <React.Fragment>
      <div className={styles['fields_margin']}>
        <div
          className={
            vinSerialNumberValid === true
              ? vinSerialNumber !== '' && 'form-group has-success'
              : vinSerialNumberValid === false && 'form-group ns-form-group-message-error'
          }
        >
          <label className="control-label" htmlFor="VinSerialNumber">
            <b>{t('your_information.vin_serial_number')}</b>
          </label>
          <div className="help-field">{t('your_information.last_four_letters')}</div>
          {vinSerialNumberValid === false && (
            <div className="ns-form-error-container has-error error-msg-align">
              <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(vinSerialNumberError)}</div>
            </div>
          )}
          <input
            type="text"
            className={['form-control', styles['field_width_100']].join(' ')}
            id="VinSerialNumber"
            // onBlur={handleOnBlur}
            value={vinSerialNumber.toUpperCase()}
            autoComplete="off"
            onChange={handleVinSerialNumber}
            onFocus={() => SetIsFocussed(true)}
            maxLength="4"
          />
          {vinSerialNumberValid === true && vinSerialNumber !== '' && (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(VinSerialNumber)
